// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notice_form *[data-v-3f793564] {\n  font-size: 1.1rem;\n}\npre[data-v-3f793564] {\n  white-space: pre-wrap; /* Since CSS 2.1 */\n  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\n  /*white-space: -pre-wrap;      !* Opera 4-6 *!*/\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word; /* Internet Explorer 5.5+ */\n}\n.vgt-global-search__actions .badge[data-v-3f793564]:hover {\n  cursor: pointer;\n}\n\n", ""]);
// Exports
module.exports = exports;
